import { Injectable } from '@angular/core';
import { ApiBaseService } from 'sharedServices/api-base.service';
import { AppConfigService } from 'sharedServices/app-config.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CommunicationService extends ApiBaseService {
    constructor(appConfig: AppConfigService, http: HttpClient) {
        super(appConfig, http);
    }

    requestDisclosureDocument = (emailAddress?: string): Observable<any> => {
        return this.http.post(
            `${this.baseUrl()}/Communication/RequestDisclosureDocument`,
            { emailAddress },
            {
                headers: this.headers(),
                responseType: 'json',
            },
        );
    };
}
